import { createAsyncThunk } from '@reduxjs/toolkit';
import { IThunkApi } from '../../types/redux';
import {
  fetchPublicMyHomeV1GetGeocode,
  IPublicMyHomeV1GetGeocodeResponse200 as IRes200,
  IPublicMyHomeV1GetGeocodeResponse400 as IRes400,
} from '../../../common/repositories/newbuilding-estimate/my-home/v1/get-geocode';
import { isEmpty } from 'ramda';
import {
  setIsNebuilding,
  setNewbuildingInfo,
  setNewbuildingSectionsList,
  setNewbuildingSection,
  resetNewbuildingState,
} from '../../slices';

import { getFlatAreasSuggest } from '../getFlatAreasSuggest';

import { newbuildingSectionsListMapper } from './mappers/newbuildingSectionsListMapper';

export const getGeocode = createAsyncThunk<void, string, IThunkApi>('getGeocode', async (address, _thunkApi) => {
  const {
    extra: { httpApi, logger },
    dispatch,
  } = _thunkApi;

  return fetchPublicMyHomeV1GetGeocode<IRes200, IRes400>({
    httpApi,
    parameters: {
      address,
    },
  })
    .then(response => {
      if (response.statusCode === 200) {
        const { newbuilding, newbuildingHouses, selectedHouseIndex } = response.response;

        if (newbuilding && !isEmpty(newbuilding)) {
          dispatch(setIsNebuilding(true));
          dispatch(setNewbuildingInfo(newbuilding));

          if (selectedHouseIndex !== undefined) {
            dispatch(setNewbuildingSection(newbuildingHouses[selectedHouseIndex as number].id));
            dispatch(setNewbuildingSectionsList(newbuildingSectionsListMapper(newbuildingHouses)));
          }
        } else {
          dispatch(resetNewbuildingState());
          dispatch(getFlatAreasSuggest(address));
        }
      }

      return Promise.reject(response);
    })
    .catch(response => {
      logger.error(response);
    });
});
